import { Box, Text } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { Outlet } from 'react-router';

import { EvolveLogo, VStack } from '@/components';
import { settings } from '@/settings';

import { authLayoutCss } from './AuthLayout.styles';

export const AuthLayout = ({ children }: PropsWithChildren) => {
  return (
    <VStack className="AuthLayout" css={authLayoutCss}>
      <Box className="panel content">
        <Box className="brand">
          <EvolveLogo width="160px" />
          <Text className="app-name">{settings.APP_NAME}</Text>
        </Box>
        {children}
      </Box>
    </VStack>
  );
};

export const AuthLayoutOutlet = () => (
  <AuthLayout>
    <Outlet />
  </AuthLayout>
);
